<template>
  <div class="area-recommend">
    <img
      v-for="(item, index) in currentAreaRecommendAreaList"
      :key="index"
      :src="item.img"
      v-stat.click="{ tag: 'area-recommend.area_click', ext: { farea: item.key } }"
      @click="changeArea(item.key)"
    />
  </div>
</template>

<script lang="ts" setup>
import { useConfigStore, useLocationStore } from '@/store';
import { AreaKey } from '@/types/area';
import { storeToRefs } from 'pinia';
import { nextTick } from 'vue';

// store
const { currentAreaRecommendAreaList } = storeToRefs(useConfigStore());
const { setArea } = useLocationStore();

function changeArea(key: AreaKey) {
  setArea(key);
  nextTick(() => {
    // 滚动到顶部
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  });
}
</script>

<style lang="less" scoped>
@import (reference) '~@/less/main';
.area-recommend {
  display: flex;
  justify-content: space-between;
  img {
    width: 335 / @rem;
    height: 227 / @rem;
  }
}
</style>
